var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coda-comment"},[_c('div',{ref:"container",staticClass:"coda-comment_container"},_vm._l((_vm.annotPos),function(pos,index){return _c('div',{key:index,ref:pos.id,refInFor:true,style:(`top:${pos.y}px;left:${pos.x + 50}px;`),attrs:{"id":pos.id}},[_c('div',{staticClass:"baloon-comment"},[_vm._v(_vm._s(pos.page))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }